export const TROLLEY_PRICING_REQUEST = 'waitrose/pricing/CUSTOMER_SLOT_REQUEST';
export const TROLLEY_PRICING_REQUEST_SUCCESS = 'waitrose/pricing/CUSTOMER_SLOT_REQUEST_SUCCESS';
export const TROLLEY_PRICING_REQUEST_FAIL = 'waitrose/pricing/CUSTOMER_SLOT_REQUEST_FAIL';

export const TROLLEY_PRICING_REQUEST_ACTIONS = [
  TROLLEY_PRICING_REQUEST,
  TROLLEY_PRICING_REQUEST_SUCCESS,
  TROLLEY_PRICING_REQUEST_FAIL,
];
